var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "history"
  }, [_c("div", {
    staticClass: "app-page-header"
  }, [_c("div", {
    staticClass: "left"
  }, [_c("el-button", {
    attrs: {
      type: "text",
      size: "mini"
    },
    on: {
      click: _vm.create
    }
  }, [_vm._v("新增")])], 1)]), _c("el-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      size: "mini",
      data: _vm.dataList,
      border: "",
      stripe: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "date",
      label: "催函方式"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "name",
      label: "催函记录"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "催函附件",
      prop: "address"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "催函人",
      prop: "address"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "催函日期",
      prop: "address"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "操作",
      prop: "address"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-button", {
          staticClass: "clean-padding",
          attrs: {
            type: "text",
            size: "mini",
            icon: "el-icon-edit",
            title: "编辑"
          }
        }), _c("el-button", {
          staticClass: "clean-padding",
          attrs: {
            type: "text",
            size: "mini",
            title: "删除",
            icon: "el-icon-delete"
          }
        })];
      }
    }])
  })], 1), _c("div", {
    staticClass: "dialog-btn-wrap"
  }, [_c("el-button", {
    attrs: {
      size: "mini"
    },
    on: {
      click: _vm.cancel
    }
  }, [_vm._v("关闭")])], 1), _vm.template ? _c(_vm.template, {
    tag: "component"
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };